import React from 'react';
import { getCurrentYear } from '../../../../functions';

export const CopyRight = () => {
  return <small>Copyright © {getCurrentYear()} Get U There. All Rights Reserved.</small>;
};
